// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2ZF-T","list":"BalanceDue_list__33BrO","listRow":"BalanceDue_listRow__2UWu3","total":"BalanceDue_total__2jlxQ"};